import axios, { AxiosResponse, AxiosRequestConfig } from "axios";

import { ServerValidationErrorResponse } from "./interface";
import { postRequest } from "@/Utils";
import { CreateFreshDeskTicketRequest } from "@/Contracts";

const createFreshDeskTicketURL = "/v2/create-freshdesk-ticket";

interface AxiosCurlirizeRequestConfig extends AxiosRequestConfig {
	curlirize: boolean;
}

export const genericPostConfig = (
	url: string,
	data: { [key: string]: any } = {},
	headers: { [key: string]: string } = {}
): AxiosRequestConfig => {
	const options: AxiosCurlirizeRequestConfig = {
		method: "POST",
		url,
		data,
		headers,
		curlirize: false
	};

	return options;
};

const API_KEY = process.env.REACT_APP_FRESHDESK_API_KEY;

const FD_ENDPOINT = "zomentum";

const PATH = "/api/v2/tickets";
const URL = "https://" + FD_ENDPOINT + ".freshdesk.com" + PATH;

enum Responders {
	// Tickets in Freshdesk will be created in their names
	STELLA_BABU = 2043083145686,
	SHASHANK_JHA = 2043100508856
}

export const createFreshDeskTicket = async (
	request: CreateFreshDeskTicketRequest
) => {
	try {
		await axios(
			postRequest(createFreshDeskTicketURL, request, true, false, false)
		);
	} catch (error) {
		Promise.reject(error);
	}
};

export const createNewTicket = async (fields: {
	email: string;
	subject: string;
	description: string;
	phone: string;
}) => {
	const config = genericPostConfig(
		URL,
		{
			responder_id: Responders.SHASHANK_JHA,
			type: "Custom-Request",
			priority: 4,
			status: 2,
			custom_fields: {
				cf_product_module: "Others",
				cf_ticket_priority: "Major"
			},
			source: 1,
			...fields
		},
		{
			Authorization: "Basic " + API_KEY,
			"Content-Type": "application/json"
		}
	);

	try {
		const response: AxiosResponse<ServerValidationErrorResponse> =
			await axios(config);
		return response.data;
	} catch (error) {
		console.error(error);
		return Promise.reject(error);
	}
};
